export default __webpack_public_path__ + "static/media/ReleaseNotes_ApplyButton.315bfba8.png";